import API from '../../api';

const types = {
  GET_QUERIES_SUCCESS: 'GET_QUERIES_SUCCESS',
  GET_QUERIES_ERROR: 'GET_QUERIES_ERROR',
  CREATE_QUERY_SUCCESS: 'CREATE_QUERY_SUCCESS',
  BATCH_QUERY_SUCCESS: 'BATCH_QUERY_SUCCESS',
  DELETE_QUERY_SUCCESS: 'DELETE_QUERY_SUCCESS',
}

const state = {
  all: []
}

const getters = {
  byId: state => id => {
    return state.all.find(item => item.id == id);
  },
}

const actions = {
  get({ commit }, params) {
    return API.queries.get(params).then(response => {
      commit(types.GET_QUERIES_SUCCESS, response.data.result);
      return response;
    }).catch(error => {
      commit(types.GET_QUERIES_ERROR);
    });
  },

  create({ commit }, queryLog) {
    return API.queries.create(queryLog).then(response => {
      const queryLog = response.data.result;
      commit(types.CREATE_QUERY_SUCCESS, queryLog);

      return queryLog;
    });
  },

  fetch({ commit, getters }, id) {
    let queryLog = getters.byId(id);
    if (queryLog) {
      return queryLog;
    }

    return API.queries.fetch(id).then(response => {
      const queryLog = response.data.result;

      return queryLog;
    });
  },

  batch({ commit }, params) {
    return API.queries.batch(params).then(response => {
      const logs = response.data.result;
      commit(types.BATCH_QUERY_SUCCESS, logs);

      return logs;
    });
  },

  delete({ commit }, queryLog) {
    return API.queries.delete(queryLog.id).then(response => {
      commit(types.DELETE_QUERY_SUCCESS, queryLog);
    });
  },
}

const mutations = {
  [types.GET_QUERIES_SUCCESS](state, queries) {
    state.all = queries;
  },

  [types.GET_QUERIES_ERROR](state) {
    state.all = [];
  },

  [types.CREATE_QUERY_SUCCESS](state, queryLog) {
    state.all.push(queryLog);
  },

  [types.BATCH_QUERY_SUCCESS](state, logs) {
    state.all = state.all.concat(logs);
  },

  [types.DELETE_QUERY_SUCCESS](state, queryLog) {
    let index = state.all.findIndex(item => item.id == queryLog.id);
    state.all.splice(index, 1);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
